import { useState } from "react";

const useSearch = (options, optionProperty) => {
    const [search, setSearch] = useState("");

    const filteredOptions = options?.filter((option) => option[optionProperty]?.toString().toLowerCase()?.includes(search?.toLowerCase()));

    const handleSearchChange = (value) => setSearch(value);

    const resetSearch = () => setSearch("");

    return {
        search, resetSearch, filteredOptions, handleSearchChange, 
    };
};

export default useSearch;
